//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import dayjs from 'dayjs';
//#endregion

/**
 * 유해·위험 기계·기구 - 기계·기구·설비 (HAZ_BASIC_01) 전용 로직
 * other 케이스에서 사용
 */

// 기계·기구·설비 인쇄 함수 (PrintLogic1)
export const PrintLogic1 = async (
  documentData,
  dispatch,
  setLoading,
  rowData1,
  searchRef,
  userInfo
) => {
  setLoading(true);

  try {
    const currentYear = dayjs().year();
    const headerData = {
      CURRENT_YEAR: currentYear,
    };

    const tableData = await Promise.all(
      rowData1.map(async (item) => {
        let machineImageBase64 = null;

        if (item.machineImageFilePath) {
          try {
            const fixedPath = Commons.EncodeUrl(item.machineImageFilePath);
            const imageUrl = Global.file.useUrl + 'files/' + fixedPath;

            const response = await fetch(imageUrl);
            if (response.ok) {
              const blob = await response.blob();
              const base64Image = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
              });

              if (base64Image && base64Image.startsWith('data:')) {
                machineImageBase64 = base64Image.replace(
                  /^data:image\/[a-z]+;base64,/,
                  ''
                );
              }
            }
          } catch (error) {
            machineImageBase64 = null;
          }
        }
        return {
          NO: item.no || '',
          INITIAL_REGULAR: item.initialRegular || '',
          MACHINE_NAME: item.machineName || '',
          TYPE: item.type || '',
          INSTALL_LOCATION: item.installLocation || '',
          DEPARTMENT: item.department || '',
          PERSON_IN_CHARGE: item.personInCharge || '',
          MAIN_STRUCTURE_SPEC: item.mainStructureSpec || '',
          MANUFACTURER: item.manufacturer || '',
          SERIAL_NO: item.serialNo || '',
          INITIAL_INSTALL_DATE: item.initialInstallDate
            ? dayjs(item.initialInstallDate).format('YYYY-MM-DD')
            : '',
          PASS_NO: item.passNo || '',
          INSPECTION_AGENCY: item.inspectionAgency || '',
          INSPECTOR: item.inspector || '',
          REMARK: item.remark || '',
          MACHINE_IMAGE: machineImageBase64 || null,
          INSPECTION_DATE: item.inspectionDate
            ? dayjs(item.inspectionDate).format('YYYY-MM-DD')
            : '',
          VALIDITY_DATE: item.validityDate
            ? dayjs(item.validityDate).format('YYYY-MM-DD')
            : '',
          INSPECTION_CYCLE: item.inspectionCycle || '',
        };
      })
    );

    const printData = {
      FileName: 'HAZ_BASIC_01',
      HeaderData: JSON.stringify(headerData),
      TableData: JSON.stringify(tableData),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    return response.data; // Blob 반환
  } catch (e) {
    console.error(e);
    dispatch(showSnackbar({ message: e.message, type: 'error' }));
    return null;
  } finally {
    setLoading(false);
  }
};

